import script from "./NotePagination.vue?vue&type=script&setup=true&lang=js"
export * from "./NotePagination.vue?vue&type=script&setup=true&lang=js"

import "./NotePagination.vue?vue&type=style&index=0&id=3d377a93&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d377a93"]])

export default __exports__